import { Stack, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/system';
import { GradientBar } from './GradientBar';

type Props = {
  min: number;
  max: number;
  color: string;
};
export const GradientScale = ({ min, max, color }: Props) => {
  return (
    <GradientContainer spacing={1} direction='column'>
      <GradientBar color={color} />
      <Stack
        sx={{ flexGrow: 1, justifyContent: 'space-between' }}
        direction='row'
      >
        <ScaleLabel>{min}</ScaleLabel>
        <ScaleLabel>{max}</ScaleLabel>
      </Stack>
    </GradientContainer>
  );
};

const GradientContainer = styled(Stack)({
  flex: 1,
});

const ScaleLabel = (
  props: Omit<TypographyProps, 'variant' | 'variantMapping'>
) => {
  return <Typography {...props} variant='caption' />;
};
